/** Mirrors `AiDocumentReviewMode` in para-node (`src/constants/ai-document-review.constants.ts`). */
export enum AiDocumentReviewMode {
  Shadow = 'shadow',
  Active = 'active',
}

/** Mirrors `AiDocumentReviewAllowedActions` in para-node (`src/constants/ai-document-review.constants.ts`). */
export enum AiDocumentReviewAllowedActions {
  All = 'all',
  ApproveOnly = 'approve_only',
  DeclineOnly = 'decline_only',
  None = 'none',
}
